import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import type { ClientRow } from '../../api';
import { useData } from '../../useData';
import { ErrorMsg, Modal } from '../../components/Modal';
import { expiryStatus, fmtDate } from '../../lib/clients';
import { formatPhone } from '../../lib/dialCodes';

/** Lista clienților unei aplicații „Clienți”. */
export function ClientsPage() {
  const appId = Number(useParams().appId);
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const [query, setQuery] = useState('');
  const [choosing, setChoosing] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setQuery(q.trim()), 300);
    return () => clearTimeout(t);
  }, [q]);
  const { data, error, loading } = useData<{ clients: ClientRow[]; canCreate: boolean }>(
    `/apps/${appId}/clients${query ? `?q=${encodeURIComponent(query)}` : ''}`);

  return (
    <>
      <div className="page-head">
        <h1>Clienți</h1>
        {data?.canCreate && <button className="primary" onClick={() => setChoosing(true)}>+ Client nou</button>}
      </div>
      <ErrorMsg error={error} />
      {choosing && (
        <Modal title="Client nou" onClose={() => setChoosing(false)}>
          <div className="type-choice">
            <button onClick={() => navigate(`/a/${appId}/nou?tip=PF`)}>
              <span className="tc-icon">👤</span>
              <strong>Adaugă client persoană fizică</strong>
              <span className="muted small">Persoană — cu CNP și acte de identitate</span>
            </button>
            <button disabled title="Formularul pentru persoane juridice urmează">
              <span className="tc-icon">🏢</span>
              <strong>Adaugă client persoană juridică</strong>
              <span className="muted small">Firmă — în curând</span>
            </button>
          </div>
        </Modal>
      )}
      <input className="search" placeholder="Caută după nume, ID, telefon, e-mail sau CNP…" value={q} onChange={(e) => setQ(e.target.value)} autoFocus />
      {loading && !data && <p className="muted">Se încarcă…</p>}
      {data && data.clients.length === 0 && (
        <p className="muted">{query ? 'Niciun client găsit.' : 'Niciun client încă. Adăugați primul client — puteți porni de la actul de identitate.'}</p>
      )}
      {data && data.clients.length > 0 && (
        <table className="cards-mobile">
          <thead>
            <tr><th>ID</th><th>Nume</th><th>Telefon</th><th>E-mail</th><th>Localitate</th><th>Documente</th><th>Prima expirare</th></tr>
          </thead>
          <tbody>
            {data.clients.map((c) => {
              const st = expiryStatus(c.primaExpirare);
              return (
                <tr key={c.id} className="clickable" onClick={() => navigate(`/clienti/${c.id}`)}>
                  <td className="id-cell" data-label="ID">{String(c.id).padStart(6, '0')}</td>
                  <td className="cm-title"><span className="pf-pj" title={c.tipClient === 'PJ' ? 'Persoană juridică' : 'Persoană fizică'}>{c.tipClient === 'PJ' ? '🏢' : '👤'}</span> <Link to={`/clienti/${c.id}`} onClick={(e) => e.stopPropagation()}><strong>{c.nume}</strong> {c.prenume}</Link></td>
                  <td className="nowrap" data-label="Telefon">{c.telefon ? formatPhone(c.telefon) : '—'}</td>
                  <td className="muted" data-label="E-mail">{c.email ?? '—'}</td>
                  <td data-label="Localitate">{[c.localitate, c.judet].filter(Boolean).join(', ') || '—'}</td>
                  <td data-label="Documente">{c.documente || '—'}</td>
                  <td data-label="Prima expirare">{c.primaExpirare ? <>{fmtDate(c.primaExpirare)} {st && st.cls !== 'tag ok' && <span className={st.cls}>{st.label}</span>}</> : '—'}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </>
  );
}
